module.exports = ".login-claim {\n  font-family: 'Gotham Rounded';\n  color: #FFF; }\n  .login-claim h1 {\n    font-weight: bold; }\n  [svgIcon=\"cambiemos\"] {\n  width: 100%;\n  height: 2.6em;\n  fill: #757575 !important; }\n  .logo {\n  height: 2.6em; }\n  .no-padding-left {\n  padding-left: 0; }\n  .no-padding-right {\n  padding-right: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/security/login/login.component.scss
// module id = ./src/app/security/login/login.component.scss
// module chunks = main